import {
  WS_CONNECT,
  WS_DISCONNECT,
  WS_MESSAGE_RECEIVED,
  WS_STATUS_CHANGED,
  WS_ERROR
} from '../actions/types'

const initialState = {
  connections: {}, // keyed by session ID
  status: 'disconnected', // 'connecting', 'connected', 'disconnected', 'reconnecting', 'failed'
  error: null,
  lastMessage: null,
  messageHistory: []
}

export default function websocketReducer(state = initialState, action) {
  switch (action.type) {
    case WS_CONNECT: {
      const { sessionId, wsUrl } = action.payload
      
      return {
        ...state,
        connections: {
          ...state.connections,
          [sessionId]: {
            url: wsUrl,
            connectedAt: new Date().toISOString(),
            status: 'connected'
          }
        },
        status: 'connected',
        error: null
      }
    }
    
    case WS_DISCONNECT: {
      const sessionId = action.payload
      const { [sessionId]: disconnectedConnection, ...remainingConnections } = state.connections
      
      return {
        ...state,
        connections: remainingConnections,
        status: Object.keys(remainingConnections).length > 0 ? 'connected' : 'disconnected'
      }
    }
    
    case WS_STATUS_CHANGED: {
      return {
        ...state,
        status: action.payload
      }
    }
    
    case WS_ERROR: {
      return {
        ...state,
        error: action.payload,
        status: 'failed'
      }
    }
    
    case WS_MESSAGE_RECEIVED: {
      const message = action.payload
      
      return {
        ...state,
        lastMessage: message,
        messageHistory: [
          ...state.messageHistory.slice(-49), // Keep last 50 messages
          {
            ...message,
            receivedAt: new Date().toISOString()
          }
        ],
        error: null
      }
    }
    
    default:
      return state
  }
}